<template>
    <section>
    <Header 
    :header_page_data="headerPageData"
    ></Header>
      <section>
        <div class="container container-app">
            <section class="position-relative campaigns-container">
                <form @submit.prevent="saveLocation" class="mt-2">
                    <div class="row mt-5">
                        <div class="col-12">
                            <div class="row" :class="{'modal-footer-canvassing-redish pt-2': hasError(errors, 'name')}">
                                <div class="col-12">
                                    <span class="add-location-title float-left">{{ $t('add_location.title') }}</span>
                                    <div class="form-group position-relative mb-3">
                                        <input type="text" class="form-control form-control--canvassing border-bottom" v-model="form.name" id="name">
                                        <div v-if="hasError(errors, 'name')">
                                            <span class="text-danger">{{errors.name[0]}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 mb-3">
                            <input type="text" class="mini-marker-add-edit-pl form-control form-control--canvassing border-bottom" v-model="form.location.full_address" id="location">
                            <div v-if="hasError(errors, 'location')">
                                <span class="text-danger">{{errors.location[0]}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="row" :class="{'modal-footer-canvassing-redish pt-2': hasError(errors, 'reception')}">
                                <div class="col-12">
                                    <span class="add-location-title float-left mb-3">{{ $t('add_location.campaign_reception') }}</span>
                                </div>
                                <div class="col-12">
                                    <span class="starRating" id="reception">
                                        <input id="rating5" type="radio" name="rating" value="5" v-model="form.reception">
                                        <label for="rating5"></label>
                                        <input id="rating4" type="radio" name="rating" value="4" v-model="form.reception">
                                        <label for="rating4"></label>
                                        <input id="rating3" type="radio" name="rating" value="3" v-model="form.reception">
                                        <label for="rating3"></label>
                                        <input id="rating2" type="radio" name="rating" value="2" v-model="form.reception">
                                        <label for="rating2"></label>
                                        <input id="rating1" type="radio" name="rating" value="1" v-model="form.reception">
                                        <label for="rating1"></label>
                                    </span>
                                </div>
                                <div class="col-12">
                                    <span class="starRatingLabels">
                                        <span class="float-left ml-3 reception-labels">{{ $t('add_location.annoyed') }}</span><span class="float-right mr-2 reception-labels">{{ $t('add_location.happy') }}</span>
                                    </span>
                                </div>
                                <div class="col-12 mb-3">
                                    <div v-if="hasError(errors, 'reception')">
                                        <span class="text-danger">{{errors.reception[0]}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12">
                            <span class="add-location-title float-left mt-3 mb-3" id="answers">{{ $t('add_location.talking_points') }}</span>
                        </div>
                        <div v-if="hasError(errors, 'answers')">
                            <span class="text-danger">{{errors.answers[0]}}</span>
                        </div>
                        <div class="col-12">
                            <div v-for="(question, index) in currentCampaign.questions" v-if="question.is_visible == true" class="row mb-3" :class="{'modal-footer-canvassing-redish': hasError(errors.answers, question._id)}" :key="index" :id="question._id">           
                                <div class="col-12">
                                    <span class="question-text">{{question.text}}</span>
                                </div>
                                <div v-if="question.type == 'open'" class="col-12 margin-top-5">
                                    <textarea class="free-question-textarea" :placeholder="$t('add_location.response-placeholder')" :name="question._id" v-model="form.answers[question._id]"></textarea>
                                </div>
                                <div v-else v-for="(answer, indexAnswer) in question.answers" class="col-12" :key="indexAnswer">
                                    <input :type="question.type == 'single' ? 'radio' : 'checkbox'" :id="answer._id" :name="question.type == 'single' ? question._id  : answer._id" :value="answer._id" v-model="form.answers[question._id]">
                                    <label class="mr-2" :for="answer._id"><span></span><div class="answer-text">{{ answer.text }}</div></label>
                                </div>
                                <div class="col-12 mb-3">
                                    <div v-if="hasError(errors.answers, question._id)">
                                        <span class="text-danger">{{errors.answers[question._id][0]}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <span class="created-edited-label">{{ $t('add_location.created_by') }} <span class="weight-500">{{ createdBy }}</span> </span>
                        </div>
                        <div class="col-12 mb-3">
                            <span class="created-edited-label">{{ $t('add_location.edited_by') }} <span class="weight-500">{{ createdBy }}</span></span>
                        </div>
                    </div>
                    <div class="row mb-5">
                        <div class="col-6">
                            <button type="submit" class="btn shadow btn-app btn-block primaryBackground">{{ $t('add_location.save_location') }}</button>
                        </div>
                        <div class="col-6">
                            <button @click.prevent="cancelAddLocation" class="btn shadow btn-app btn-block cancelOrangeButton">{{ $t('add_location.cancel') }}</button>
                        </div>
                    </div>
                </form>
            </section>
        </div>
      </section>
    </section>
</template>

<script>
    import Header from "./../layouts/Header";
    import HelperMixin from "./../../mixins/HelperMixin";
    import { mapState } from 'vuex';

    export default {
        name: "AddLocation",
        components: {Header},
        mixins: [HelperMixin],
        data() {
            return {
                form: {
                    name: '',
                    reception: 0,
                    location: {},
                    answers: {}
                },
                errors: {
                    name: [],
                    location: [],
                    reception: [],
                    answers: []
                },
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: false,
                        type_search: ''
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                        goto: 'campaign-map'
                    },
                    profile: {
                        show: false
                    }
                }
            }
        },
        created() {
            if (typeof this.$store.getters["currentLocation"].lat == 'undefined') {
                this.goto('campaign-map', {campaign_id: this.$route.params.campaign_id});
            } else {
                this.mapAnswersErrors();
                this.form.location = this.currentLocation;
                this.mapAnswersModels();
            }
        },
        mounted() {
        },
        computed: {
            createdBy() {
                if (this.$store.getters["user"]) {
                    return this.$store.getters["user"].name;
                } else {
                     return '';
                }
            },

            currentLocation() {
                return this.$store.getters["currentLocation"];
            },

            currentCampaign() {
                return this.$store.getters["currentCampaign"];
            }
        },
        methods: {

            cancelAddLocation() {
                this.goto('campaign-map', {campaign_id: this.$route.params.campaign_id});
            },

            mapAnswersModels() {
                if (typeof this.currentCampaign.questions != 'undefined') {
                    for (var i = 0; i < this.currentCampaign.questions.length; i++) {
                        if (this.currentCampaign.questions[i].is_visible == true) {
                            if ( this.currentCampaign.questions[i].type == 'single' || this.currentCampaign.questions[i].type == 'open') {
                                this.form.answers[this.currentCampaign.questions[i]._id] = '';   
                            } else {
                                this.form.answers[this.currentCampaign.questions[i]._id] = [];
                            }
                        }
                    }
                }
            },

            mapAnswers() {
                let tmp = [];
                let _this = this;
                Object.keys( this.form.answers).forEach(function(key,index) {
                    if (Array.isArray(_this.form.answers[key])) {
                        for (var i = 0; i < _this.form.answers[key].length; i++) {
                            tmp.push({question_id: key, answer_id: _this.form.answers[key][i]});
                        }
                    } else {
                        for (var i = 0; i < _this.currentCampaign.questions.length; i++) {
                            if (key == _this.currentCampaign.questions[i]['_id']) {
                                if (_this.currentCampaign.questions[i]['type'] == 'open') {
                                    tmp.push({question_id: key, answer: _this.form.answers[key]});
                                } else {
                                    tmp.push({question_id: key, answer_id: _this.form.answers[key]});
                                }
                            }
                        }
                    }
                });
                
                return tmp;
            },

            mapAnswersErrors() {
                if (typeof this.currentCampaign.questions != 'undefined') {
                    for (var i = 0; i < this.currentCampaign.questions.length; i++) {
                        if (this.currentCampaign.questions[i].is_visible == true) {
                            this.errors.answers[this.currentCampaign.questions[i]._id] = [];
                        }
                    }
                }
            },

            saveLocation() {
                let answers = this.mapAnswers();
                this.errors = {
                    name: [],
                    location: [],
                    reception: [],
                    answers: []
                };

                this.mapAnswersErrors();

                let _this = this;
                let exit = [];
                Object.keys( this.form.answers).forEach(function(key) {
                    for (var i = 0; i < _this.currentCampaign.questions.length; i++) {
                        if (key == _this.currentCampaign.questions[i]['_id']) {
                            if (_this.currentCampaign.questions[i].type == 'open') {
                                if (_this.currentCampaign.questions[i].is_mandatory === true && _this.form.answers[key].length == 0) {
                                    _this.errors.answers[key] = [_this.$t('add_location.errors.please_complete_response')];
                                    exit.push(1);
                                }

                                if (_this.form.answers[key].length > 500) {
                                    _this.errors.answers[key] = [_this.$t('add_location.errors.response_max_length')];
                                    exit.push(1);
                                }

                                if (_this.currentCampaign.questions[i].validation == 'integer' && _this.form.answers[key].length > 0) {
                                    var valueFormat = /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g;
                                    if (_this.form.answers[key].match(valueFormat) == null) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.response_validation_number')];
                                        exit.push(1);
                                    }
                                }

                                if (_this.currentCampaign.questions[i].validation == 'email' && _this.form.answers[key].length > 0) {
                                    var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                                    if (_this.form.answers[key].match(mailformat) == null) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.response_validation_email')];
                                        exit.push(1);
                                    }
                                }
                            } else {
                                if(_this.currentCampaign.questions[i].is_mandatory === true && _this.form.answers[key].length == 0) {
                                    _this.errors.answers[key] = [_this.$t('add_location.errors.please_complete_response')];
                                    exit.push(1);
                                } 
                                
                                /* if (_this.form.answers[key].length == 0) {
                                    _this.errors.answers[key] = [_this.$t('add_location.errors.please_check')];
                                    exit.push(1);
                                }
                                */
                            }
                        }
                    }
                });

                if(this.currentCampaign.reception_mandatory == true && this.form.reception == 0) {
                    _this.errors.reception = [_this.$t('add_location.errors.reception_required')];
                    exit.push(1);
                }
                if (this.form.name == '') {
                    this.errors.name = [this.$t('add_location.errors.name_required')];
                    exit.push(1);
                }
                if (this.form.name.length < 2) {
                    this.errors.name = [this.$t('add_location.errors.name_min')];
                    exit.push(1);
                }
                if (this.form.name.length > 60) {
                    this.errors.name = [this.$t('add_location.errors.name_max')];
                    exit.push(1);
                }

                if (this.form.location.full_address == '') {
                    this.errors.location = [this.$t('add_location.errors.location_address_required')];
                    exit.push(1);
                }

                if (exit.length > 0) {
                    return false;
                }

                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };
                this.editName = false;
                let postData = {
                            name: this.form.name,
                            location: this.form.location,
                            answers: answers,
                        }
                if(this.form.reception != 0) { 
                    postData.reception = this.form.reception;
                }
                axios.post(
                        '/api/v1/campaign/' + this.currentCampaign._id + '/respondent/create',
                        postData,
                        config
                ).then(this.consumesaveLocation, this.errorsaveLocation);
            },

            consumesaveLocation: function (response) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                this.errors = {
                    name: [],
                    location: [],
                    reception: [],
                    answers: []
                };

                this.mapAnswersErrors();

                this.goto('campaign-map', {campaign_id: this.$route.params.campaign_id});


            },

            errorsaveLocation: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
                if (
                    typeof error.message != 'undefined' && 
                    error.message == 'Network Error'
                ) {

                    let answers = this.mapAnswers();
                    this.errors = {
                        name: [],
                        location: [],
                        reception: [],
                        answers: []
                    };

                    this.mapAnswersErrors();

                    let _this = this;
                    let exit = [];
                    Object.keys( this.form.answers).forEach(function(key) {
                        for (var i = 0; i < _this.currentCampaign.questions.length; i++) {
                            if (key == _this.currentCampaign.questions[i]['_id']) {
                                if (_this.currentCampaign.questions[i].type == 'open') {
                                    if (_this.currentCampaign.questions[i].is_mandatory === true && _this.form.answers[key].length == 0) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.please_complete_response')];
                                        exit.push(1);
                                    }

                                    if (_this.form.answers[key].length > 500) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.response_max_length')];
                                        exit.push(1);
                                    }

                                    if (_this.currentCampaign.questions[i].validation == 'integer' && _this.form.answers[key].length > 0) {
                                        var valueFormat = /^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g;
                                        if (_this.form.answers[key].match(valueFormat) == null) {
                                            _this.errors.answers[key] = [_this.$t('add_location.errors.response_validation_number')];
                                            exit.push(1);
                                        }
                                    }

                                    if (_this.currentCampaign.questions[i].validation == 'email' && _this.form.answers[key].length > 0) {
                                        var mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                                        if (_this.form.answers[key].match(mailformat) == null) {
                                            _this.errors.answers[key] = [_this.$t('add_location.errors.response_validation_email')];
                                            exit.push(1);
                                        }
                                    }
                                } else {
                                    if(_this.currentCampaign.questions[i].is_mandatory === true && _this.form.answers[key].length == 0) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.please_complete_response')];
                                        exit.push(1);
                                    } 
                                    
                                    /* if (_this.form.answers[key].length == 0) {
                                        _this.errors.answers[key] = [_this.$t('add_location.errors.please_check')];
                                        exit.push(1);
                                    }
                                    */
                                }
                            }
                        }
                    });

                    if(this.currentCampaign.reception_mandatory == true && this.form.reception == 0) {
                        _this.errors.reception = [_this.$t('add_location.errors.reception_required')];
                        exit.push(1);
                    }


                    if (exit.length > 0) {
                        return false;
                    }

                    let postData = {
                        offline_campaign_id: this.$route.params.campaign_id,
                        name: this.form.name,
                        location: this.form.location,
                        answers: answers,
                        created_by: {
                            id: this.$store.getters["user"]._id,
                            name: this.$store.getters["user"].name
                        },
                        status: 'pending'
                    }
                    
                    if(this.form.reception != 0) { 
                        postData.reception = this.form.reception;
                    }
                    this.$store.dispatch('saveOfflineLocation', {
                        offlineLocation: postData
                    });
                    

                    this.errors = {
                        name: [],
                        location: [],
                        reception: [],
                        answers: []
                    };

                    this.mapAnswersErrors();

                    this.goto('campaign-locations', {campaign_id: this.$route.params.campaign_id});
                }

                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined 
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.name != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.name.includes("required")) {
                                this.errors.name = [this.$t('add_location.errors.name_required')];
                            }
                            if (error.response.data.errorMessage.validation_fail.name.includes("min")) {
                                this.errors.name = [this.$t('add_location.errors.name_min')];
                            }
                            if (error.response.data.errorMessage.validation_fail.name.includes("max")) {
                                this.errors.name = [this.$t('add_location.errors.name_max')];
                            }
                        }
                        if (typeof error.response.data.errorMessage.validation_fail.location != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.location.includes("location")) {
                                this.errors.location = [this.$t('add_location.errors.location_issue')];
                            }
                        }
                        if (typeof error.response.data.errorMessage.validation_fail.answers != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.answers.includes("required")) {
                                this.errors.answers = [this.$t('add_location.errors.answers_required')];
                            }
                        }

                        
                        /*
                        if (typeof error.response.data.errorMessage.validation_fail.reception != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.reception.includes("required")) {
                                this.errors.reception = [this.$t('add_location.errors.reception_required')];
                            }
                        }
                        */               
                        if(this.currentCampaign.reception_mandatory == true && this.form.reception == 0) {
                            if (typeof error.response.data.errorMessage.validation_fail.reception != 'undefined') {
                                if (error.response.data.errorMessage.validation_fail.reception.includes("in")) {
                                    this.errors.reception = [this.$t('add_location.errors.reception_required')];
                                }
                            }
                        }       
                    }
                }
                console.log(error);
            },
        },
    };
</script>
